import { gql } from "@apollo/client";

export const userFragment = gql`
    fragment UserFragment on User {
        id
        firstname
        lastname
        email
        address
        zipCode
        city
        phone
        country
        agb
        newsletter
        aboReminder
        ecg
        cameras {
            id
            name
            activatedAt
            hardwareInfo {
                imei
                msisdn
            }
        }
    }
`;
